import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";
import { StatusBadge } from "@/utils/statusUtils";

interface OvertimeRecord {
  id: string;
  date: string;
  hours: number;
  status: string;
  justification: string;
  startTime?: string | null;
  endTime?: string | null;
  approverName?: string | null;
  approverComment?: string | null;
  submittedAt: string;
  updatedAt?: string | null;
}

interface OvertimeTableProps {
  records: OvertimeRecord[];
}

export function OvertimeTable({ records }: OvertimeTableProps) {
  // Format date from ISO to readable format
  const formatDate = (dateString: string) => {
    // Parse date string manually to avoid timezone issues
    const [year, month, day] = dateString.split(/[-T]/);
    if (year && month && day) {
      // Create date in local timezone to prevent day shifts
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
      return format(date, 'MMM d, yyyy');
    }
    return format(new Date(dateString), 'MMM d, yyyy');
  };


  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="text-center">Date</TableHead>
            <TableHead className="text-center">Hours</TableHead>
            <TableHead className="text-center">Justification</TableHead>
            <TableHead className="text-center">Status</TableHead>
            <TableHead className="text-center">Approver</TableHead>
            <TableHead className="text-center">Comments</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {records.map((record) => (
            <TableRow key={record.id}>
              <TableCell className="text-center">{formatDate(record.date)}</TableCell>
              <TableCell className="text-center">{record.hours}</TableCell>
              <TableCell className="text-center">{record.justification}</TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <StatusBadge status={record.status} />
                </div>
              </TableCell>
              <TableCell className="text-center">{record.approverName || '-'}</TableCell>
              <TableCell className="text-center">{record.approverComment || '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
